import clsx from 'clsx';
import CalcInfoBlock from 'components/CalcInfoBlock/CalcInfoBlock';
import React, { useEffect, useState } from 'react';
import styles from './StartNew.module.scss';
import { Button, Modal } from 'tt-ui-lib/core';
import {
  CALCS_PER_PAGE,
  CALC_DESCRIPTIONS,
  CALC_NAMES,
  CALC_PAGE_TYPES,
  CALC_TYPES,
} from 'utils/calculatorUtils';
import CalcIcon from '../../components/CalcIcon/CalcIcon';
import CompanySelectionModal from 'views/ScoreAndReporting/components/CompanySelectionModal/CompanySelectionModal';
import { useSelectedContext } from 'context/contextSelector';

const isProduction = process.env.REACT_APP_ENV === 'production';
const calcInDevelopnentList = {
  [CALC_TYPES.SUST_CSRD_ESRD]: true,
  [CALC_TYPES.SUST_GRI]: true,
  [CALC_TYPES.SUST_ISSB]: true,
  [CALC_TYPES.SUST_CDP]: true,
  [CALC_TYPES.CUSTOM_FILES]: isProduction,
  [CALC_TYPES.CUSTOM_REPORT]: isProduction,
  [CALC_TYPES.LOCAL]: true,
  [CALC_TYPES.GLOBAL]: true,
};

const StartNew = (props) => {
  const { targetWidth, setLoginOpen, pageType } = props;
  const { user, selectedCompany: widjetCompany } = useSelectedContext((context) => context.user);
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [isCarbonModalOpen, setIsCarbonModalOpen] = useState(false);

  const [startParams, setStartParams] = useState(null);

  const endpointCalculator = process.env.REACT_APP_ESG_CALC || '';
  const endpointReport = process.env.REACT_APP_REPORT || '';

  const redirectCalculator = (url) => {
    window.location.href = `${endpointCalculator}${url}`;
  };

  const redirectReport = (url) => {
    window.location.href = `${endpointReport}${url}`;
  };

  useEffect(() => {
    if (startParams?.name && !startParams?.companyId) {
      if (widjetCompany && widjetCompany.selectedCompany) {
        const { selectedCompany } = widjetCompany;
        setStartParams((current) => ({ ...current, companyId: selectedCompany.id }));
      } else {
        setIsCompanyModalOpen(true);
      }
      return;
    }
    if (startParams?.name && startParams?.companyId) {
      if (pageType === CALC_PAGE_TYPES.BENCHMARK) {
        redirectCalculator(`/startCalculator/${startParams.name}/${startParams.companyId}`);
      }
      if (pageType === CALC_PAGE_TYPES.CUSTOM) {
        redirectReport(`/startReport?type=${startParams.name}&companyId=${startParams.companyId}`);
      }
    }
  }, [startParams]);

  const onStartClick = (calc) => {
    if (!user?.id) {
      setLoginOpen(true);
      return;
    }
    // if user is individual they cannot use the calculator
    if (user?.role_name === 'individual') {
      setIsRoleModalOpen(true);
      return;
    }
    // if user select carbon calculator show modal with options
    if (calc === CALC_TYPES.CARBON) {
      setIsCarbonModalOpen(true);
      return;
    }
    setStartParams({ name: calc });
  };

  const onModalClose = (isCancel) => {
    if (isCancel) {
      setStartParams(null);
    }
    setIsCompanyModalOpen(false);
    setIsCarbonModalOpen(false);
  };

  return (
    <>
      <Modal
        open={isCarbonModalOpen}
        onClose={() => onModalClose(true)}
        onClick={(e) => e.stopPropagation()}
        title="TT Carbon Footprint calculator"
        containerClassName={styles.modalRoot}
        className={styles.modal}
      >
        <div className={styles.carbonModalBlock}>
          <CalcInfoBlock
            headerText="Annual assessment"
            description={`Harnessing the "Annual Assessment" option, you can assess your
              company's carbon footprint for a specific year. The company calculator
              comprehensively analyzes the annual carbon footprint of your business
              activities. As per the GHG protocol, this carbon footprint assessment
              is categorized into three scopes.`}
            onButtonClick={() => setStartParams({ name: 'carbon' })}
          />
          <CalcInfoBlock
            headerText="Project assessment"
            description={`Harnessing the "Project Assessment," you can assess the carbon
              footprint of various company projects, from house construction to
              organizing events or producing batches of products. It includes
              calculators for company operations, production, and packaging.`}
            onButtonClick={() => setStartParams({ name: 'project' })}
          />
        </div>
      </Modal>
      <Modal
        open={isRoleModalOpen}
        onClose={() => setIsRoleModalOpen(false)}
        onClick={(e) => e.stopPropagation()}
        title="Upgrade your&nbsp;role"
        className={styles.modal}
      >
        <div className={styles.text}>
          We&apos;re sorry. This functionality is not available for your role.
        </div>
        <div className={clsx(styles.buttonBlock, styles.roleBB)}>
          <Button type="default" onClick={() => setIsRoleModalOpen(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => {}}>
            Upgrade your role
          </Button>
        </div>
      </Modal>
      <CompanySelectionModal
        onFinish={(value) => setStartParams((current) => ({ ...current, companyId: value }))}
        open={isCompanyModalOpen}
        onClose={onModalClose}
      />
      <div className={styles.container}>
        <>
          {CALCS_PER_PAGE[pageType]
            .filter((calc) => calc !== CALC_TYPES.PROJECT)
            .map((calc) => (
              <CalcInfoBlock
                icon={<CalcIcon type={calc} />}
                headerText={CALC_NAMES[calc]}
                description={CALC_DESCRIPTIONS[calc]}
                onButtonClick={() => onStartClick(calc)}
                isDisabled={calcInDevelopnentList[calc]}
                targetWidth={targetWidth}
              />
            ))}
        </>
      </div>
    </>
  );
};

export default StartNew;
